import { useState} from 'react'
import { getBlueprint } from '../api-client/data'
import { uuidv4 } from '../util/hash'
import { useDispatch, useSelector, Actions } from '../stores/dashboard.store'
import useFetch from "../hooks/useFetch"
import { listConnections } from '../api-client/data'
import { SettingsNavigationItems } from '../config/nav'

export default (setNodes, nodes) => {
    const [autoCorrectNodes, setAutoCorrectNodes] = useState([])
    const [showAutocompleteFull, setShowAutoCompleteFull] = useState({ visible: false, data: undefined})
    
    const connections = useFetch(listConnections)

    const { plan } = useSelector()
    const dispatch = useDispatch()

    const setShowAutoComplete = (val) => setShowAutoCompleteFull({ visible: val, data: undefined})

    const onAutocompleteSelect = async ({ flow, accessibility, id, ...rest }) => {
        setShowAutoComplete(false)

        if (!plan?.nodeAccessibility.includes(accessibility)) {
            dispatch(Actions.SetDashboardError, { title: 'Upgrade Plan', description: 'You must upgrade your plan to use this feature.'})
            return
        }

        if (rest?.requiredConnection.length > 0) {
            const connection = connections.data.find(x => x?.accountId === rest?.requiredConnection)
            
            if (connection?.id === undefined) {
                dispatch(Actions.SetDashboardError, {
                    title: "Connection Required",
                    description: "To use this node, you must first connect to the 3rd party application",
                    navigation: { nav: SettingsNavigationItems._id, view: SettingsNavigationItems.Connections },
                })
                return
            }
        }
 
        if (nodes?.length + 1 > plan?.maxWorkflowNodes) {
            dispatch(Actions.SetDashboardError, { title: 'Exceeded Nodes', description: 'You have exceeded the max number of nodes for your account plan.'})
            return
        }

        let data = { ...rest, id }
        if (rest?.isProject) {
            const project = await getBlueprint(id)
            data = {
                description: "",
                name: rest?.name,
                repeatable: false,
                projectId: id,
                inputs: project?.data?.io?.inputs,
                outputs: project?.data?.io?.outputs,
                version: project?.version
            }
        } else {
            data.inputs = data.inputs.map(x => ({ ...x, id: uuidv4()}))
            data.outputs = data.outputs.map(x => ({ ...x, id: uuidv4()}))
        }

        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        setNodes((prev) => [
            ...prev,
            {
                id: uuidv4(),
                type: 'customNode',
                position: { x: (screenWidth / 2 - flow.x) / flow.zoom, y: (screenHeight / 2 - flow.y) / flow.zoom },
                sourcePosition: 'right',
                data,
            }
        ])
    }

    const onDoubleClick = (e) => {
        if (e.detail == 2) {
            setShowAutoComplete(true)
            return
        }

        if (showAutocompleteFull?.visible && e.target.id == 'OutsideDialogContainer') {
            setShowAutoComplete(false)
        }
    }

    return {
        onAutocompleteSelect,
        showAutocomplete: showAutocompleteFull?.visible,
        showAutocompleteFull,
        onDoubleClick,
        setAutoCorrectNodes,
        autoCorrectNodes,
        setShowAutoComplete,
        setShowAutoCompleteFull
    }
}